import { ClientDetailResponse } from "@/api";
import { FormDialog } from "@/common/components/form-dialog/FormDialog";
import { useTranslation } from "@/translations";

import { CaseNoteForm } from "../case-note-form/CaseNoteForm";
import { useCaseNoteCreation } from "./hooks/useCaseNoteCreation";

interface Props {
  client: ClientDetailResponse;
  onClose: () => void;
}

export function CaseNoteCreationDialog({ client, onClose }: Props) {
  const { t } = useTranslation();
  const { formik, typeOptions, locationOptions, resultOptions, appointmentStatusOptions, isConversationType } =
    useCaseNoteCreation(client, onClose);

  return (
    <FormDialog
      title={t("clients.client.caseNotes.creationDialog.title")}
      onClose={onClose}
      formik={formik}
      submitLabel={t("common.create")}
    >
      <CaseNoteForm
        formik={formik}
        clientId={client.clientId}
        typeOptions={typeOptions}
        locationOptions={locationOptions}
        resultOptions={resultOptions}
        appointmentStatusOptions={appointmentStatusOptions}
        isConversationType={isConversationType}
      />
    </FormDialog>
  );
}
